/**
 * Trigger event catalog — single source of truth for the front-end trigger
 * pipeline. Mirrors the backend CHECK constraint in
 * `pm_task_template_trigger.event_type`.
 *
 * Adding a new event later is a 3-line change:
 *   1. Append the constant here.
 *   2. Add the human label in TRIGGER_EVENT_LABELS.
 *   3. Register the handler in `triggerRegistry.js`.
 *
 * The backend CHECK constraint also has to be widened via a new migration.
 */
export const TRIGGER_EVENTS = {
  LEAD_MOVE_STAGE_TO_WON: 'lead.move_stage_to_won',
}

export const TRIGGER_EVENT_LABELS = {
  [TRIGGER_EVENTS.LEAD_MOVE_STAGE_TO_WON]: 'Quando lead é arrastado para Ganho',
}

/**
 * Returns the human-friendly label for an event-type key. Falls back to the
 * raw key so the UI never shows blank cells if a new backend event ships
 * without a label entry (defensive).
 */
export function getTriggerEventLabel(eventType) {
  if (!eventType) return ''
  return TRIGGER_EVENT_LABELS[eventType] || eventType
}

/**
 * Catalog as v-select items — used by the form modal `eventType` field.
 */
export function getTriggerEventOptions() {
  return Object.values(TRIGGER_EVENTS).map(function (value) {
    return { text: getTriggerEventLabel(value), value: value }
  })
}
